let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6WxgL")).then(() => parcelRequire('i0mY9'));